import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/store'
import vuetify from './plugins/vuetify'
import AxiosPlugin from './plugins/axios'
import MomentPlugin from './plugins/moment'
import FullWidthLayout from './layouts/FullWidthLayout.vue'
import MainLayout from './layouts/MainLayout.vue'
import ErrorPageLayout from './layouts/ErrorPageLayout.vue'
import VeeValidatePlugin from './plugins/vee-validate'
import 'vue-loading-overlay/dist/vue-loading.css'
import '@/styles/main.scss'
import DatetimePicker from 'vuetify-datetime-picker'
import VueCurrencyFilter from 'vue-currency-filter'
import ProjectLayout from './layouts/ProjectLayout'

Vue.use(AxiosPlugin)
Vue.use(MomentPlugin)
Vue.use(VeeValidatePlugin)
Vue.use(DatetimePicker)
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
  avoidEmptyDecimals: undefined
})

Vue.component('full-width-layout', FullWidthLayout)
Vue.component('main-layout', MainLayout)
Vue.component('project-layout', ProjectLayout)
Vue.component('error-page-layout', ErrorPageLayout)
Vue.component('DatePicker', () => import('@/components/date-picker/DatePicker.vue'))
Vue.component('DataTable', () => import('@/components/data-table/DataTable.vue'))
Vue.component('DateTimePicker', () => import('@/components/date-time-picker/DateTimePicker.vue'))

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
